import styled, {css} from "styled-components";
import HomepageTypeIcon from "./HomepageTypeIcon";
import __ from "../../utils/translator";
import themeResponsiveProperty from "../responsive/themeResponsiveProperty";
import {typologies} from "../organisms/HomepageCard";
import HomepageCardTypologyTitle from "./HomepageCardTypologyTitle";

export default function HomepageCardTitle({
  typology,
  children
}) {
  return (
    <TitleContainer typology={typology}>
      <HomepageCardTypologyTitle typology={typology} />
      <Title>{children}</Title>
    </TitleContainer>
  )
}

const TitleContainer = styled.div`
  background: ${themeResponsiveProperty("linear-gradient(360deg, #000000 12.64%, rgba(0, 0, 0, 0) 50%), linear-gradient(0deg, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2))", "transparent")};
  min-height: 10.625rem;
  ${props => props.typology === typologies.seasonal && css`
    margin-left: ${themeResponsiveProperty('0', '2.5rem')};
    width: ${themeResponsiveProperty('100%', '31.25rem')};
  `}
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: end;
  gap: .25rem;
  padding: ${themeResponsiveProperty('.5rem 1rem', '4.4rem 1.25rem .5rem 1.25rem')};
`;

const Title =styled.span`
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: ${themeResponsiveProperty('1.6875rem', '2.5rem')};
  line-height: ${themeResponsiveProperty('2rem', '3rem')};
  color: #FFF;
  font-weight: 300;
  font-style: normal;
`;
